<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">
    <page-title :title="title" />
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <profile-edit
          @addnew="(value) => addnew(value)"
          class="mt-4"
          :endPoint="getEndPoint" 
          :uploadEndpoint="uploadEndpoint"
        />
        <div class="p-4">
   <vs-button
          class="ml-4 mt-2"
          type="border"
          color="warning"
          @click="cancelChanges"
        >Back to List</vs-button>
        </div>
     
      </div>
    </vx-card>
  </div>
</template>

<script>
import profileEdit from "../profile_edit.vue";

import PageTitle from "../../components/aron/pageTitle";
import AronTable from "../../components/aron/table/tblmain";

import { mapGetters } from "vuex";

/*
Guide
1. UPDATE getAddionalData() method to add your own method
2.

*/

export default {
  components: {
    profileEdit,
    PageTitle,
    AronTable
  },
  data() {
    return {
      editPage: "edit_pr", //when user click the add new button
      uploadEndpoint: "/uploadFile",
      title: this.getEndPoint,
      endPoint: this.getEndPoint,
      activeTab: 0, 
    };
  }, 
   
  methods: {
    cancelChanges() {
      this.$router.go(-1);
    },
    
    addnew(response) {
      //we need to set this record because the tabs will be needing this
      //as their foreignkeys
      this.$store.dispatch("profile/setProfileId", response.id);
      this.$store.dispatch("profile/setMainInfo", response);
    }
  },
  computed: {
    ...mapGetters({
      getEndPoint: "profile/getEndPoint",
      getCallBack: "profile/getCallBack",
      getUserInfo: "auth/getUserInfo"
    })
  },
  created() {}
};
</script>
